import { Component, OnInit,Input  } from '@angular/core';
import { SharedService } from './../shared.service';
/*import { TranslateService } from '@ngx-translate/core';*/
import { Subscription } from 'rxjs/Subscription';
import { languageList } from '../globalConfig';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	isDesktopView : boolean;
  languageList: any;   
  public currentPage: string;
  username = "";
  password = "";
  loginError = '';
  //showAgencyInformation : boolean;
  private currentPageSubscription : Subscription;
  public agencyDetails : object;
  constructor(
    private sharedService : SharedService,
    /*public translate: TranslateService,*/
    private router:Router
    ) {
  	this.isDesktopView = this.sharedService.getDeviceType();  	
    /*this.translate.setDefaultLang('en');*/
  }

  ngOnInit() {
    this.languageList = languageList;
  }

  ngDoCheck() {
    //this.showAgencyInformation = this.sharedService.showAgencyInformation;
    this.agencyDetails = this.sharedService.getAgencyDetails();
  }
  logout(){
    this.sharedService.clearSession();
    this.sharedService.signOut().subscribe((response) => {
      console.log(response);
    });
    this.router.navigate(['/externalRedirect', { externalUrl: environment.taPortal }]);
  }
  
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/header/header.component.ts